/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
}
const useStyles = makeStyles(styles)

export default function PYSetupProfileList(props) {
    const classes = useStyles(props)
    return (
        <List
            sort={{ field: 'FieldName', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Setup Profile" />
                <Datagrid rowClick="edit">
                    <TextField
                        label="Field Name"
                        headerClassName={classes.myHeader}
                        source="FieldName"
                    />
                    <TextField
                        label="n Value"
                        headerClassName={classes.myHeader}
                        source="nValue"
                    />
                    <TextField
                        label="n Group"
                        headerClassName={classes.myHeader}
                        source="nGroup"
                    />
                    <EditButton basePath="/PY_SetupProfileTAB" />
                </Datagrid>
            </>
        </List>
    )
}
